import styled from 'styled-components';

import { breakpoints } from 'utils/mixins';
import { fontSize, space } from 'theme/sizes';
import { toRem } from 'utils/mixins';
import { neutral, danger } from 'theme/colors';

export const Wrapper = styled.div`
  position: relative;
  margin: 0;
  margin-bottom: ${space.xs};
  width: 100%;

  .input__input {
    position: relative;
    padding-bottom: ${space.m};

    label {
      display: block;
      position: absolute;
      left: ${space.xxs};
      top: ${toRem(27)};
      transform: translateY(-50%);
      color: ${neutral.neu09};
      margin: 0;
      z-index: 2;
      padding: ${space.tiny} ${space.xxs};
      background-color: ${neutral.neu01};
      border-radius: ${space.s};
    }

    input,
    textarea {
      margin: 0;
      width: 100%;
      min-height: ${space.l};
      padding: ${space.xs} ${space.xs};
      border: ${toRem(1)} solid ${neutral.neu06};
      outline: none;
      padding-right: ${(props) => props.icon && space.l};
      resize: none;
    }

    &.input__select {
      width: 100%;
      background-color: white;

      label {
        pointer-events: none;
      }

      li {
        margin: 0;
      }

      &.input__select--active .input__select-select {
        transform: scaleY(1);
      }

      &.input__select--active .input__select-filter:after {
        transform: rotate(-135deg) translateY(-50%);
      }

      .input__select-options-filter {
        width: 100%;
        cursor: pointer;
      }

      .input__select-filter {
        position: relative;
        margin: 0;
        width: 100%;
        border: ${toRem(1)} solid ${neutral.neu06};
        outline: none;
        padding-right: ${(props) => props.icon && space.l};
        resize: none;

        &:focus {
          outline: none;
        }

        &::after {
          position: absolute;
          top: 50%;
          right: 20px;
          content: '';
          width: 10px;
          height: 10px;
          border-right: 2px solid #595959;
          border-bottom: 2px solid #595959;
          transform: rotate(45deg) translateY(-50%);
          transition: 0.2s ease-in-out;
          transform-origin: center center;
        }
      }

      .input__select-filter-selected {
        min-height: ${space.l};
        padding: ${space.xxs} ${space.xs};
        display: flex;
        align-items: center;
        font-family: inherit;
        font-size: 100%;
        line-height: 1.15;
        font-weight: 400;
      }

      .input__select-select {
        position: absolute;
        z-index: 20;
        top: 100%;
        left: 0;
        width: 100%;
        overflow: hidden;
        box-shadow: 0 5px 10px 0 rgba(152, 152, 152, 0.6);
        background-color: ${neutral.neu01};
        transform: scaleY(0);
        transform-origin: top;
        font-weight: 300;
        transition: 0.2s ease-in-out;
        max-height: 300px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: ${space.xxs};
          background: transparent;
        }

        &::-webkit-scrollbar-track {
          border-radius: ${space.xxs};
        }

        &::-webkit-scrollbar-thumb {
          border-radius: ${space.xxs};
          background: ${neutral.neu08};
        }
      }

      .input__select-select-option {
        padding: 20px;
        background-color: #fff;
        border-bottom: 1px solid #d6d6d6;
        transition: 0.3s;
        margin: 0;

        &:last-of-type {
          border-bottom: 0;
        }

        &:hover {
          background-color: #f9f9f9;
        }
      }
    }

    &--file {
      label {
        display: block;
        position: absolute;
        left: ${space.xxs};
        top: ${toRem(27)};
        transform: translateY(-50%);
        color: ${neutral.neu09};
        margin: 0;
        z-index: 2;
        padding: ${space.tiny} ${space.xxs};
        background-color: ${neutral.neu01};
        border-radius: ${space.s};

        display: block;
        position: absolute;
        left: ${space.xxs};
        top: 0 !important;
        transform: translateY(-90%) scale(0.85) !important;
        background-color: unset;
        color: ${neutral.neu09};
        margin: 0;
        z-index: 2;
        border-radius: ${space.s};
      }

      input[type='file'] {
        /* Style the color of the message that says 'No file chosen' */
        resize: none;
        width: ${`calc(100% - ${space.m})`};
        height: 100%;
        outline: none;
        padding: 0;
        border: none;
        background-color: transparent;
        color: ${neutral.neu09};
        margin: ${space.xxs} 0;

        &::-webkit-file-upload-button {
          cursor: pointer;
          outline: none;
          border: none;
          text-decoration: none;
          color: ${neutral.neu01};
          background-color: ${neutral.neu09};
          box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
          border-radius: ${space.xxs};
          min-height: ${toRem(44)};
          padding: 0 18px;
        }
      }
    }
  }

  .input__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    padding: 2px;
    transform: translateY(-50%);
    right: 12px;
    line-height: 1;
    color: ${neutral.neu09};
  }

  .input__error-msg {
    height: ${toRem(32.5)};
    position: absolute;
    bottom: 0;
    margin: 0;
    color: ${danger.default};
    font-size: ${toRem(13)};
  }

  @media ${breakpoints.tablet} {
    width: ${(props) => (props.half ? '48%' : '100%')};
  }
`;
